<script>
export default {
    name: "ComponentTableExpandMixin",
    methods: {
        toggleExpand(item, header) {
            item.toggleExpanded();
            header.single && this.mappedItems.forEach(e => {
                if (e !== item) {
                    if (e.expanded) {
                        header.unexpanded(e.raw);
                        e.expanded = false;
                    }
                }
            });
            item.expanded
                ? header.expanded && header.expanded(item.raw) :
                header.unexpanded && header.unexpanded(item.raw);
        },
    },
}
</script>